import { Component } from '@angular/core';
import { delay, tap } from 'rxjs';
import { LoaderService } from '@modules/shared/services/loader.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { TokenRefreshService } from '@modules/shared/services/token-refresh.service';
import { CommonService } from '@modules/shared/services/common.service';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    public isLoaderOn: boolean = false;

    constructor(
        private _loaderService: LoaderService,
        private http: HttpClient,
        private tokenRefreshService: TokenRefreshService,
        private commonService: CommonService,
        private router: Router,
        private appService: AppService

    ) { }

    ngOnInit() {
        const token = this.commonService.getItem('access_token');
        if (token) {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const now = Date.now() / 1000;
            if (payload.exp < now) {
                console.warn('Access token is already expired. Logging out.');
                this.appService.logout();
                this.router.navigate(['/login']);
            }
        }

        this.tokenRefreshService.checkAndRefreshNow();
        this.tokenRefreshService.startRefreshing(); // ✅ start token refresh loop
    }
    ngAfterViewInit() {
        // add delay in subscribtion to facilitate change detection
        this._loaderService.castLoader
            .pipe(
                delay(0),
                tap((loader) => this.loader(loader))
            ).subscribe();
    }

    public loader(data: any) {
        if (data === 'showloader') {
            this.isLoaderOn = true;
        } else if (data === 'hideloader') {
            this.isLoaderOn = false;
        }
    }
}
